import type { Appointment } from '~/api/graphql/generated/types'

interface AppointmentReasonCellProps {
  item: Appointment
}

const AppointmentWidgetReasonCell = ({ item }: AppointmentReasonCellProps) => {
  const reasonName = item.appointmentReason?.name

  return <span>{reasonName ?? '--'}</span>
}

export default AppointmentWidgetReasonCell
